var _path, _circle, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPptxIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2762 0H4.32736C3.59507 0 3 0.599733 3 1.3416V22.6584C3 23.3995 3.59507 24 4.32736 24H20.2591C20.993 24 21.5865 23.3995 21.5865 22.6584V5.3664L16.2762 0ZM16.2762 1.8968L19.7097 5.3664H16.2762V1.8968ZM20.2594 22.6584H4.32736V1.3416H14.9486V5.3664C14.9486 6.10747 15.5424 6.708 16.276 6.708H20.2591L20.2594 22.6584Z",
    fill: "#CA4E2D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.25,
    cy: 14.5,
    r: 5.5,
    fill: "#D95835"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.75 14.5C17.75 13.7777 17.6077 13.0625 17.3313 12.3952C17.0549 11.728 16.6498 11.1216 16.1391 10.6109C15.6284 10.1002 15.022 9.69506 14.3548 9.41866C13.6875 9.14226 12.9723 9 12.25 9L12.25 14.5H17.75Z",
    fill: "#FE9370"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPptxIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pptx-icon.1b8bee62c8fea571826689531877f33d.svg";